// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__MO84Q","featured":"styles_featured__g510_"};